import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-12" }, "ログイン", -1)
const _hoisted_4 = {
  key: 0,
  role: "status",
  "aria-live": "polite",
  class: "w-3/4 mb-6 whitespace-pre-line rounded-lg bg-blue-50 p-4 text-sm leading-relaxed text-gray-800"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ログイン画面に戻る ")
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-500 mb-8" }, [
  /*#__PURE__*/_createTextVNode(" ログインを以って "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://mingaku.notion.site/6eaef296e774833d96d18183c51918d9",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "text-primary-500 transition-colors duration-300 hover:text-primary-600"
  }, " プライバシーポリシー "),
  /*#__PURE__*/_createTextVNode("および "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://mingaku.notion.site/73def296e77483e8a0a481ffa6301255",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "text-primary-500 transition-colors duration-300 hover:text-primary-600"
  }, "利用規約"),
  /*#__PURE__*/_createTextVNode("に同意します ")
], -1)
const _hoisted_7 = { class: "w-3/4 mb-8" }
const _hoisted_8 = { class: "w-3/4 mb-12" }
const _hoisted_9 = { class: "flex flex-col items-center gap-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ログイン ")
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 初めてログインする場合、もしくはパスワードを忘れた場合はこちら ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_GoogleLoginButton = _resolveComponent("GoogleLoginButton")
  const _component_MicrosoftLoginButton = _resolveComponent("MicrosoftLoginButton")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      (_ctx.emailNotice)
        ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.emailNotice), 1))
        : _createCommentVNode("", true),
      (_ctx.emailNotice && !_ctx.busy)
        ? (_openBlock(), _createBlock(_component_m_button, {
            key: 1,
            class: "mb-6",
            color: "primary-500",
            "hover-color": "primary-600",
            "font-size": "base",
            onClick: _ctx.returnToLogin
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _hoisted_6,
      (!_ctx.emailNotice)
        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_m_text_field, {
                label: "メールアドレス",
                name: "email",
                type: "email",
                placeholder: "example@mingaku.net",
                invalid: !_ctx.validEmail,
                "invalid-message": "メールアドレスが正しくありません",
                entered: _ctx.enteredEmail,
                value: _ctx.email,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredEmail = true))
              }, null, 8, ["invalid", "entered", "value"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_m_text_field, {
                label: "パスワード",
                name: "password",
                type: "password",
                placeholder: "8文字以上の英数字・記号",
                invalid: !_ctx.validPassword,
                "invalid-message": "パスワードは8文字以上の英数字・記号で入力してください",
                entered: _ctx.enteredPassword,
                value: _ctx.password,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                onEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enteredPassword = true))
              }, null, 8, ["invalid", "entered", "value"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                "font-size": "base",
                disabled: _ctx.busy || (!_ctx.valid && _ctx.allEntered),
                onClick: _ctx.signIn
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_GoogleLoginButton, { onClick: _ctx.moveToGoogleLinkageUrl }, null, 8, ["onClick"]),
              _createVNode(_component_MicrosoftLoginButton, { onClick: _ctx.moveToMicrosoftLinkageUrl }, null, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/setting_password",
                class: "text-gray-500 text-sm underline transition-all duration-300 cursor-pointer hover:text-gray-700"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}